// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { SvgIcon, SvgIconProps } from '@mui/material';
import cx from 'classnames';

type Classes = Pick<SvgIconProps, 'classes'>;

interface Props extends Omit<SvgIconProps, 'classes'>, Classes {
  className?: string;
  color?: 'primary' | 'secondary';
}

const WarningIcon: React.FC<Props> = (props) => {
  const classes = withStyles.getClasses(props);
  const { color = 'primary' } = props;

  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} classes={{ root: cx(classes.root, classes[color]) }}>
      <path
        d="M17.8489 16.1405L11.1133 3.66347C10.6359 2.77884 9.36411 2.77884 8.8863 3.66347L2.15114 16.1405C2.04748 16.3325 1.99551 16.5481 2.0003 16.7661C2.0051 16.9842 2.06649 17.1973 2.17848 17.3846C2.29048 17.572 2.44925 17.7271 2.63931 17.835C2.82936 17.9428 3.0442 17.9997 3.26286 18H16.7352C16.954 18 17.1691 17.9434 17.3594 17.8357C17.5497 17.728 17.7088 17.5729 17.821 17.3855C17.9332 17.1981 17.9948 16.9849 17.9997 16.7666C18.0046 16.5484 17.9526 16.3327 17.8489 16.1405ZM10 16.0683C9.84367 16.0683 9.69085 16.0221 9.56087 15.9355C9.43088 15.8488 9.32957 15.7257 9.26975 15.5816C9.20992 15.4375 9.19427 15.279 9.22477 15.1261C9.25527 14.9731 9.33055 14.8327 9.44109 14.7224C9.55163 14.6121 9.69247 14.537 9.8458 14.5066C9.99912 14.4762 10.1581 14.4918 10.3025 14.5515C10.4469 14.6111 10.5704 14.7122 10.6572 14.8419C10.7441 14.9715 10.7904 15.124 10.7904 15.2799C10.7904 15.489 10.7071 15.6895 10.5589 15.8374C10.4107 15.9853 10.2096 16.0683 10 16.0683ZM10.8584 8.13863L10.6315 12.9481C10.6315 13.1154 10.5649 13.2758 10.4463 13.3941C10.3278 13.5124 10.1669 13.5788 9.99921 13.5788C9.8315 13.5788 9.67067 13.5124 9.55208 13.3941C9.4335 13.2758 9.36687 13.1154 9.36687 12.9481L9.14002 8.1406C9.13493 8.02572 9.15307 7.911 9.19337 7.80326C9.23367 7.69552 9.2953 7.59698 9.37459 7.51351C9.45388 7.43004 9.54921 7.36335 9.65489 7.31741C9.76058 7.27147 9.87445 7.24723 9.98973 7.24612H9.99802C10.1141 7.24606 10.229 7.26946 10.3357 7.3149C10.4425 7.36034 10.5389 7.42688 10.6191 7.51051C10.6994 7.59414 10.7618 7.69312 10.8027 7.80149C10.8435 7.90985 10.8619 8.02534 10.8568 8.141L10.8584 8.13863Z"
      />
    </SvgIcon>
  );
};

const WarningIconStyled = withStyles(
  WarningIcon, 
  (theme, props) => ({
    "root": {},
    "primary": {
      '& > *': {
        color: theme.palette.colors.error,
      }
    },
    "secondary": {
      '& > *': {
        color: theme.palette.colors.warning,
      }
    }
  })
);

export default WarningIconStyled;